import { IPersistClientKeys, IServerClientKeys } from 'mod/store/clientKeys/interface';

export function getPersistClientKeys(serverClientKeys: IServerClientKeys, countryCode: string): IPersistClientKeys {
    const persistClientKeys = {} as IPersistClientKeys;
    for (const key1 in serverClientKeys) {
        const value1 = serverClientKeys[key1];
        const value2 = value1[countryCode] || value1['DEFAULT'];
        persistClientKeys[key1] = value2;
    }
    return persistClientKeys;
}